var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAgendaIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Agenda",
    d: "M0,15.406A1.6,1.6,0,0,0,1.607,17H13.393A1.6,1.6,0,0,0,15,15.406V6.375H0ZM2.143,9.031A.535.535,0,0,1,2.679,8.5H5.893a.535.535,0,0,1,.536.531v3.188a.535.535,0,0,1-.536.531H2.679a.535.535,0,0,1-.536-.531Zm11.25-6.906H11.786V.531A.535.535,0,0,0,11.25,0H10.179a.535.535,0,0,0-.536.531V2.125H5.357V.531A.535.535,0,0,0,4.821,0H3.75a.535.535,0,0,0-.536.531V2.125H1.607A1.6,1.6,0,0,0,0,3.719V5.313H15V3.719A1.6,1.6,0,0,0,13.393,2.125Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAgendaIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/agenda_icon.04f75c77.svg";
export { ForwardRef as ReactComponent };